export type Category = 'cricut' | 'goldsmith' | 'teva' | 'modeling3d' | 'svgfiles' | 'sublimation';
// export type Category = 'cricut' | 'goldsmith' | 'teva' | 'modeling3d' | 'svgfiles' | 'sublimation' | 'others';

export const CATEGORIES: Record<Category, string> = {
  cricut: 'cricut',
  goldsmith: 'goldsmith',
  teva: 'teva',
  modeling3d: 'modeling3d',
  svgfiles: 'svgfiles',
  sublimation: 'sublimation'//,
  // others: 'others'
} as const;

export const CATEGORY_OPTIONS: { value: Category; label: string }[] = [
  { value: 'cricut', label: 'Cricut' },
  { value: 'goldsmith', label: 'Goldsmith' },
  // { value: 'others', label: 'Others' },
  { value: 'teva', label: 'Sustainable Art' },
  { value: 'modeling3d', label: 'Modeling 3D' },
  { value: 'svgfiles', label: 'SVG Files' },
  { value: 'sublimation', label: 'Sublimation' }
]; 